import { createUseStyles } from 'react-jss';
import { ITheme } from '../../components/theme';

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: '200px',
    },
  },
};
export const selectErrorWrapper = {
  color: '#d32f2f',
};

type RuleNames =
  | 'mainBlock'
  | 'formWrapper'
  | 'formTop'
  | 'tabsBlock'
  | 'createBtn'
  | 'avatar'
  | 'mainTitle';

const PREFIX = 'ViewProfile';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      mainBlock: {
        width: '1160px',
        margin: '0 auto',
        '& .MuiTypography-root': {
          fontFamily: theme.helveticaNeue,
        },
        '& .MuiTableCell-root': {
          fontFamily: theme.helveticaNeue,
        },
        '& .MuiPaper-root': {
          fontFamily: theme.helveticaNeue,
        },
        '& .MuiOutlinedInput-root': {
          fontSize: 14,
          fontFamily: theme.helveticaNeue,
          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              border: '1px solid black',
            },
          },
        },
        '& .MuiFormLabel-root': {
          color: '#999999',
        },
        '& .MuiInputLabel-shrink': {
          color: theme.darkGreen,
        },
      },
      mainTitle: {
        '& .MuiTypography-root': {
          fontFamily: theme.caslonDoric,
          fontSize: 20,
          color: theme.darkGreen,
        },
      },
      formWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        margin: '32px 0',
        '& label.Mui-focused': {
          color: 'black',
        },
        gap: '20px',
      },
      formTop: {
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: '1fr 1fr 1fr',
        gridGap: '28px',
        justifyContent: 'space-between',
      },
      avatar: {
        clipPath: 'circle(50% at center)',
        width: 100,
        height: 100,
        objectFit: 'cover',
      },
      createBtn: {
        backgroundColor: theme.lightGreen,
        color: theme.darkGreen,
        padding: '6px 16px',
        '&:hover': {
          backgroundColor: theme.hoverLightGreen,
        },
      },
      tabsBlock: {
        height: '36px',
        margin: '32px 0 24px',
        display: 'flex',
        justifyContent: 'space-between',
      },
    }
  ),
  { name: PREFIX },
);
